import type { UseMutationResult } from "@tanstack/react-query"
import { useMutation, useQueryClient } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import type { StartArcadiaGreenButtonConnectionResponseDto } from "../dto/arcadia-green-button.dto"
import { arcadiaGreenButtonService } from "../services/arcadia-green-button.service"

type ResendArcadiaGreenButtonConnectionEmailParams = {
  connectionId: string
  proposalId: string
  siteId: string
}

export const useResendArcadiaGreenButtonConnectionEmail = (): UseMutationResult<
  StartArcadiaGreenButtonConnectionResponseDto,
  unknown,
  ResendArcadiaGreenButtonConnectionEmailParams,
  unknown
> => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ connectionId, proposalId, siteId }) =>
      arcadiaGreenButtonService.resendConnectionEmail(
        siteId,
        connectionId,
        proposalId,
      ),
    onSuccess: (_data, { siteId }) => {
      void queryClient.invalidateQueries({
        queryKey: queryKeys.arcadiaGreenButton.site(siteId),
      })
    },
  })
}
